import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import * as serviceWorkerRegistration from './ServiceWorkerNewAPICall';
import store from './app/store'
import { Provider } from 'react-redux';
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from './api/sso/msalconfig';
import { registerLicense } from '@syncfusion/ej2-base';
export const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById('root'));

if ('serviceWorker' in navigator) {
  let lspublicurl = "";
  if (process.env.PUBLIC_URL !== undefined && process.env.PUBLIC_URL !== "" && process.env.PUBLIC_URL !== null) {
    lspublicurl = process.env.PUBLIC_URL;
  }
  navigator.serviceWorker.register(lspublicurl + '/ServiceWorkerNew.js?v=' + process.env.REACT_APP_VERSION)
    .then((registration) => {
      console.log('Service Worker registered with scope:', registration.scope);
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
}
msalInstance.enableAccountStorageEvents();

// Registering Syncfusion license key
registerLicense('Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXZcdHRTRGNfVEZzXUI=');

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});
root.render(
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <App />
    </Provider>
  </MsalProvider>
);

// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register();

